
function productTabs(load){
  //Identify each tab
  var tabContent = $('#product-tabs ul');
  var tabHeader = $('#product-tabs h3');
  
  //Apply css
  $(tabContent).addClass('tabContent');
  $(tabHeader).addClass('tabHeader');

  //Add click listeners to tab headers
  $(tabHeader).on('click',function(){
    $('#product-tabs ul.show').removeClass('show');
    $(tabHeader).removeClass('on');
    $(this).toggleClass('on').next('.tabContent').addClass('show');
  });

  var load = load;
  if (load === true){
    $('#product-tabs h3:first').trigger('click');
  }
}

  // Sticky header
function stickyHeader(enable){

  if (enable = true){
    var headerHeight = $('header').height();
    $(window).scroll(function(){ 
    // if scrolled down more than the header’s height
        if ($(window).scrollTop() > headerHeight){ 
        $('header').addClass('sticky');
        $('body').css('margin-top',headerHeight);
      } else {
        $('header').removeClass('sticky');
        $('body').css('margin-top',0);
      }
    });
  } else if (enable = false){
    $('header').removeClass('sticky');
  } 
}


function colourPhotoSwitch(colour){
  //find any thumbnails with the colour in the name
  var colour = colour.toLowerCase();
  var photoThumbs = $('li.product-photo-thumb img');
 
  photoThumbs.each(function(){
    var photoSrc = $(this).attr('src');
    if(photoSrc.indexOf(colour) != -1){
      $(this).parent('a').click();
    }
  });
}


jQuery(function($){

  windowWidth = $( window ).width();

  $('html').removeClass('no-js');
                    
  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });


  /* Product Menu Toggle */
  /*==========================*/
  $('#product-type-toggle').on('click',function(){

    if (!$(this).hasClass('open')){

      if (windowWidth > 1024){
        var mapHeight = ($('#product-type li').size()/7)*150;
        $('#product-type').css('height',mapHeight);
      } else if (windowWidth < 528) {
        var mapHeight = ($('#product-type li').size()/2)*150;
        $('#product-type').css('height',mapHeight);
      } else {
        var mapHeight = ($('#product-type li').size()/4)*160;
        $('#product-type').css('height',mapHeight);
      }
    } else {
      $('#product-type').css('height',0);
    }

    $(this).toggleClass('open');
    $('#product-type').toggleClass('open');
  });


  /* Sticky header */
  /*==========================*/
  //stickyHeader(true);


  /* Wide only function */
  /*==========================*/
  $(window).resize(function() {
    windowWidth = $(window).width();
  });

  if (windowWidth > 528){
   
  }


  /* Product Image Gallery Handler */
  /*==========================*/
  $('li.product-photo-thumb a').on('click',function(){
      var newSrc = $(this).children('img').attr('src').replace('compact','grande');
      $('#product-photo-container').find('img').attr('src',newSrc);

      $('li.product-photo-thumb a').removeClass('current');
      $(this).addClass('current');
      return false;
  });


  /* Nav Toggle */
  /*==========================*/
  $('.nav-toggle').on('click',function(){
    $('.nav, .nav-culture').toggle();
    // Close the product nav when you close the nav if it's open
    if ($('#product-type-toggle').hasClass('open')){
      $('#product-type-toggle').click();
    }
  });

  $('.utility-toggle').on('click',function(){
    $('.utility').toggle();
  });


  /* Search Toggle */
  /*==========================*/
  $('.big-search a').on('click',function(){
    $('body').toggleClass('open-bigsearch');
    $('#big-search').find('#search-field').focus();
    return false;
  });

  $('.close-bigsearch').on('click',function(){
    $('body').toggleClass('open-bigsearch');
    return false;
  });



});
